export class MarkerInfos {
  id: number;
  coord: any;
  nom: string;
  flag: string;
  pays: string;
  islocalite: boolean;

  /* Correspond au marker le plus proche si recherche sur une localite non touché */
  markerLinked: MarkerInfos;

  constructor(id, coord, nom, flag, pays, islocalite) {
    this.id = id;
    this.coord = coord;
    this.nom = nom;
    this.flag = flag;
    this.pays = pays;
    this.islocalite = islocalite;
  }

  setLinkedMarker(markerLinked) {
    this.markerLinked = markerLinked;
  }

  getLinkedMarker() {
    return this.markerLinked;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/map/markerInfos.ts